<template>
    <nav class="navbar navbar-area navbar-expand-lg" :class="{ 'sticky-active': scrollPosition >= 445, }" >
        <div class="container nav-container navbar-bg">
            <div class="responsive-mobile-menu">
                <button class="menu toggle-btn d-block d-lg-none" data-target="#itech_main_menu" 
                aria-expanded="false" aria-label="Toggle navigation">
                    <span class="icon-left"></span>
                    <span class="icon-right"></span>
                </button>
            </div>
            <div class="logo">
                <router-link to="/">
                    <img :src="require('@/assets/img/logo.png')" alt="img">
                </router-link>
            </div>
            <div class="nav-right-part nav-right-part-mobile">
                <a class="search-bar-btn" id="search-bar-btn" href="javascript:void(0)">
                    <i class="fa fa-search"></i>
                </a>
            </div>
            <div class="collapse navbar-collapse" id="itech_main_menu">
                <ul class="navbar-nav menu-open text-lg-end">
                    <li class="menu-item-has-children">
                        <router-link to="/">Inicio</router-link>
                    </li>
                    <li class="menu-item-has-children">
                        <a href="javascript:void(0)">Service</a>
                        <ul class="sub-menu">
                            <li><router-link to="/service">Service</router-link></li>
                            <li><router-link to="/service-single">Service Single</router-link></li>
                        </ul>
                    </li>
                    <li class="menu-item-has-children">
                        <a href="javascript:void(0)">Pages</a>
                        <ul class="sub-menu">
                            <li><router-link to="/about">About Us</router-link></li>
                            <li><router-link to="/team">Team</router-link></li>
                            <li><router-link to="/team-details">Team Details</router-link></li>
                            <li><router-link to="/case-study">Case Study</router-link></li>
                            <li><router-link to="/case-study-details">Case Study Details</router-link></li>
                            <li><router-link to="/pricing">Pricing</router-link></li>
                            <li><router-link to="/404">404</router-link></li>
                        </ul>
                    </li>
                    <li class="menu-item-has-children">
                        <a href="javascript:void(0)">Blog</a>
                        <ul class="sub-menu">
                            <li><router-link to="/blog">Blog</router-link></li>
                            <li><router-link to="/blog-details">Blog Details</router-link></li>
                        </ul>
                    </li>
                    <li><router-link to="/contact-us">Contact Us</router-link></li>
                </ul>
            </div>
            <div class="nav-right-part nav-right-part-desktop align-self-center">
                <a class="search-bar-btn" id="search-bar-btn" href="javascript:void(0)">
                    <img :src="require('@/assets/img/search.png')" alt="img">
                </a>
                <router-link to="/contact-us" class="btn btn-base">Get In Touch</router-link>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "Header2",
        data: function () {
            return {
                scrollPosition: null,
            };
        },
        methods: {
            updateScroll() {
                this.scrollPosition =
                    window.scrollY;
            },
        },
        mounted() {
            window.addEventListener(
                "scroll",
                this.updateScroll
            );

            const menu = document.querySelector('.navbar-area .menu');
            const navbarCollapse = document.querySelector('.navbar-area .navbar-collapse');

            menu.addEventListener('click', function () {
                this.classList.toggle('open');
                navbarCollapse.classList.toggle('sopen');
            });

            const menuItems = document.querySelectorAll('.navbar-nav .menu-item-has-children')

            menuItems.forEach((menuItem) => {
                const subMenu = menuItem.querySelector('.sub-menu')
                if (subMenu) {
                    menuItem.addEventListener('click', function () {
                        if (subMenu.style.display === 'block') {
                            subMenu.style.display = 'none';
                        } else {
                            subMenu.style.display = 'block';
                        }
                    })
                }
            });
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/Header2.vue